import { lazy, Suspense } from "react";

import { useAppSelector } from "@liberty-fund/data-context/hooks";
import type { AccountState } from "@liberty-fund/data-context/types";
import { Loader } from "@/ui/components";

import DashboardButtons from "@/components/DashboardButtons";
import DashboardNextBoardMeeting from "@/components/DashboardNextBoardMeeting";

const ObservationsApproved = lazy(
  () =>
    import("@/modules/board/components/Observations/ObservationsApproved/index"),
);

const ConferencesInterest = lazy(
  () =>
    import("@/modules/board/components/Observations/ConferencesInterest/index"),
);

const ObservationsRequestsPendingApproval = lazy(
  () =>
    import(
      "@/modules/board/components/Observations/ObservationsRequestsPendingApproval/index"
    ),
);

const Dashboard = () => {
  const { roles } = useAppSelector<AccountState>((state) => state.account);

  return (
    <>
      <DashboardNextBoardMeeting />

      {roles?.length ? (
        <>
          {roles.includes("portal:board:viewer") && <DashboardButtons />}
          {roles.includes("portal:board:requestor") && (
            <Suspense
              fallback={
                <div className="py-10">
                  <Loader text={"Approved Observations"} />
                </div>
              }
            >
              <ObservationsApproved />
            </Suspense>
          )}
          {roles.includes("portal:board:approver") && (
            <Suspense
              fallback={
                <div className="py-10">
                  <Loader text={"Observations Pending Approval"} />
                </div>
              }
            >
              <ObservationsRequestsPendingApproval testId="host-dashboard" />
            </Suspense>
          )}
          {(roles.includes("portal:board:requestor") ||
            roles.includes("portal:board:approver")) && (
            <Suspense
              fallback={
                <div className="py-10">
                  <Loader text={"Conferences Interest"} />
                </div>
              }
            >
              <ConferencesInterest />
            </Suspense>
          )}
        </>
      ) : null}
    </>
  );
};

export default Dashboard;
